(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Ouvre/ferme le méga-menu "Produits" au survol de la souris (en plus du clic déjà géré par dropdown.js)
  document.addEventListener('DOMContentLoaded', function () {
    var megamenuItems = document.querySelectorAll('.header__menu-item--megamenu');

    megamenuItems.forEach(function (item) {
      var closeTimeout;

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimeout);
        if (typeof item.open === 'function') {
          item.open();
        }
      });

      item.addEventListener('mouseleave', function () {
        closeTimeout = setTimeout(function () {
          if (typeof item.close === 'function') {
            item.close();
          }
        }, 150);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
